// extracted by mini-css-extract-plugin
export default {"user-actions":"UserList_user-actions__uZY9I"};